import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';

export function EstimationSummary({
  selectedLens,
  selectedTranscriptIds,
  setSelectedTranscriptIds,
  data: _data,
  setActiveStep,
  handleEstimationAgree,
}) {
  const handleBack = () => {
    // Go back to transcript selection (step 1) for all lenses
    setActiveStep(1);
    setSelectedTranscriptIds([]);
  };
  return (
    <Container maxWidth="xll">
      <Grid container spacing={2}>
        {/* Analysis Summary Card */}
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ height: '100%', p: 1 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Analysis Summary
              </Typography>
              <List dense disablePadding>
                <ListItem disableGutters sx={{ py: 0.5 }}>
                  <ListItemText
                    primary="Selected Lens"
                    secondary={
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.primary"
                        sx={{ fontWeight: 'medium' }}
                      >
                        {selectedLens?.name}
                      </Typography>
                    }
                    primaryTypographyProps={{ color: 'text.secondary', variant: 'body2' }}
                  />
                </ListItem>
                <ListItem disableGutters sx={{ py: 0.5 }}>
                  <ListItemText
                    primary="Selected Transcripts"
                    secondary={
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.primary"
                        sx={{ fontWeight: 'medium' }}
                      >
                        {selectedTranscriptIds.length || 'All'} transcripts selected
                      </Typography>
                    }
                    primaryTypographyProps={{ color: 'text.secondary', variant: 'body2' }}
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>

        {/* Analysis Units Cost Card */}
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ height: '100%', p: 1 }}>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                Analysis Units Required
              </Typography>
              <List dense disablePadding>
                <ListItem
                  disableGutters
                  sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}
                >
                  <ListItemText
                    primary="Transcript Analysis"
                    primaryTypographyProps={{ color: 'text.secondary', variant: 'body2' }}
                  />
                  <Typography variant="body2" color="text.primary" sx={{ fontWeight: 'medium' }}>
                    {selectedTranscriptIds?.length || 0}{' '}
                    {selectedTranscriptIds?.length === 1 ? 'unit' : 'units'}
                  </Typography>
                </ListItem>
                <ListItem
                  disableGutters
                  sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}
                >
                  <ListItemText
                    primary="Overall Synthesis"
                    primaryTypographyProps={{ color: 'text.secondary', variant: 'body2' }}
                  />
                  <Typography variant="body2" color="text.primary" sx={{ fontWeight: 'medium' }}>
                    1 unit
                  </Typography>
                </ListItem>
                <Divider sx={{ my: 1 }} />
                <ListItem
                  disableGutters
                  sx={{ display: 'flex', justifyContent: 'space-between', py: 0.5 }}
                >
                  <ListItemText
                    primary="Total Analysis Units"
                    primaryTypographyProps={{ color: 'text.primary', fontWeight: 'bold' }}
                  />
                  <Typography variant="body1" color="primary.main" sx={{ fontWeight: 'bold' }}>
                    {(selectedTranscriptIds?.length || 0) + 1} units
                  </Typography>
                </ListItem>
              </List>
              <Link
                href="https://qualz.ai/docs/userguide/entitlements/"
                target="_blank"
                underline="hover"
                color="primary"
                sx={{ mt: 2, display: 'block' }}
              >
                Learn more about entitlements
              </Link>
            </CardContent>
          </Card>
        </Grid>

        {/* Alert Message */}
        <Grid item xs={12}>
          <Alert
            severity="info"
            iconMapping={{ info: <InfoOutlinedIcon fontSize="inherit" /> }}
            sx={{
              borderRadius: 2,
              backgroundColor: '#fffbe5',
              color: '#856404',
            }}
          >
            <Typography variant="body2">
              After analysis is complete, results will be available in the <b>Analysis Results</b>{' '}
              tab. You&apos;ll receive a notification when the analysis is ready.
            </Typography>
          </Alert>
        </Grid>
      </Grid>

      {/* Action Buttons */}
      <Box
        sx={{
          mt: 3,
          display: 'flex',
          justifyContent: 'space-between',

          mx: 'auto',
          width: '100%',
        }}
      >
        <Button variant="outlined" onClick={handleBack}>
          Back
        </Button>
        <Button variant="contained" onClick={handleEstimationAgree} disabled={!selectedLens}>
          Start Analysis
        </Button>
      </Box>
    </Container>
  );
}
